import "./LocationScoutingSetDesignCrewScheduling.module.css";
import Header from "@/reusable_sections/Header";
import LocationScoutingAndManagement from "./sections/LocationScoutingAndManagement";
import SetDesignAndPropCoordination from "./sections/SetDesignAndPropCoordination";
import CrewAndProductionScheduling from "./sections/CrewAndProductionScheduling";
import GetStartedContactCta from "./sections/GetStartedContactCta";
import Footer from "@/reusable_sections/Footer";
export default function LocationScoutingSetDesignCrewSchedulingPage() {
  return <div>
      <Header />
      <LocationScoutingAndManagement />
      <SetDesignAndPropCoordination />
      <CrewAndProductionScheduling />
      <GetStartedContactCta />
      <Footer />
    </div>;
}